import { setI18nConfig } from '@front/i18n';

import { init as initRequester, setAuthorizationToken } from '../api/requester';
import { LOCALES_BY_COUNTRY } from '../constants/country';
import { init as initDucks } from '../ducks/utils';
import { ErrorNotifier } from '../errors/error-notifier';

import { setMomentLocale } from './moment';
import { getCurrentCountry } from './country';

type InitializeArgs = {
  appName: string;
  authToken?: string | null;
  baseURL: string;
  errorNotifier: ErrorNotifier;
  i18nConfig: {
    translations: {
      fr: object;
      en: object;
    };
    locale: string;
  };
  setCountry: (() => Promise<void>) | (() => void);
};

export const initialize = async ({
  appName,
  authToken,
  baseURL,
  errorNotifier,
  i18nConfig,
  setCountry,
}: InitializeArgs) => {
  await setCountry();

  setI18nConfig({
    ...i18nConfig,
    notifier: errorNotifier.notify,
    defaultLocale: LOCALES_BY_COUNTRY[getCurrentCountry()],
  });
  setMomentLocale();

  if (authToken) {
    setAuthorizationToken(authToken);
  }

  initRequester(baseURL, appName);
  initDucks(errorNotifier);
};
